import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-view" }
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = { class: "form-options" }
const _hoisted_4 = { class: "auth-links" }
const _hoisted_5 = { class: "links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "title" }, "欢迎回来", -1)),
      _cache[9] || (_cache[9] = _createElementVNode("p", { class: "subtitle" }, "登录您的AiVitaHelper账号", -1)),
      _createVNode(_component_el_form, {
        ref: "loginFormRef",
        model: _ctx.loginForm,
        rules: _ctx.rules,
        class: "login-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { prop: "identifier" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.loginForm.identifier,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.identifier) = $event)),
                placeholder: "账号/邮箱",
                "prefix-icon": _ctx.User
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "password" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.loginForm.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.password) = $event)),
                type: "password",
                placeholder: "密码",
                "prefix-icon": _ctx.Lock,
                "show-password": ""
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.loginForm.rememberMe,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginForm.rememberMe) = $event))
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("记住我")
              ])),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/forgot-password",
                class: "auth-link"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" 忘记密码？ ")
                ])),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/restore-account",
                class: "auth-link"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" 恢复账号 ")
                ])),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "submit-btn",
            loading: _ctx.loading,
            onClick: _ctx.handleLogin
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode(" 登录 ")
            ])),
            _: 1
          }, 8, ["loading", "onClick"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/register",
              class: "register-link"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("创建账号")
              ])),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}